import { Directive, ElementRef, HostListener, inject } from "@angular/core";


declare const bootstrap: {
  Offcanvas: {
    getInstance(element: Element): { hide(): void } | null;
  };
};

@Directive({
    selector: '[toggleMobileMenu]',
    standalone: true
})
export class UiWebHeaderMenuToggleDirective {
  private el = inject(ElementRef);

  constructor() {}

  @HostListener('click', ['$event'])
  toggleMobileMenu($event: any) {
    const navigationEl = document.getElementById('navbarContent');
    if(navigationEl) {
      const bsOffcanvas = bootstrap.Offcanvas.getInstance(navigationEl);
      if(bsOffcanvas) {
        bsOffcanvas.hide();
      }
    }
  }

}